import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="clouds-container">
        <div className="cloud cloud1"></div>
        <div className="cloud cloud2"></div>
        <div className="cloud cloud3"></div>
        <div className="cloud cloud4"></div>
      </div>
      <div className="content-container">
        <div className="logo-container">
          <img src="/favicon.ico" className="logo" alt="Translucent Logo" />
        </div>
        <h1 className="coming-soon">Coming Soon</h1>
        <div className="social-buttons">
          <a 
            href="https://x.com/translucentrade" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="x-button"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" className="x-icon">
              <g>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
              </g>
            </svg>
            Follow on X
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
